export const setToken = (token) => (dispatch) => {
    dispatch({ type: 'SET_TOKEN', payload: token });
}

export const removeToken = () => (dispatch) => {
    dispatch({ type: 'REMOVE_TOKEN' });
}